import config from '../nyConfig'
const ApiQuestion = {
    "问题列表": new config({ url: '/assess/questionList', showSuccessMessage: false, useToken: true }),
    "添加问题": new config({ url: '/assess/questionAdd', showSuccessMessage: true, useToken: true }),
    "修改问题": new config({ url: '/assess/questionEdit ', showSuccessMessage: true, useToken: true }),
    "添加答案": new config({ url: '/assess/answerAdd ', showSuccessMessage: true, useToken: true }),
    "编辑答案": new config({ url: '/assess/answerEdit ', showSuccessMessage: true, useToken: true }),
    "答案列表": new config({ url: '/assess/answerList ', showSuccessMessage: false, useToken: true }),
    "问题字典列表": new config({ url: '/assess/questionDictionaryList', showSuccessMessage: false, useToken: true }),
}

export default ApiQuestion